import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CacheEvidencesInitiator, CacheUsersInitiator } from '../enums/cache-lists-initiator';

@Injectable({
  providedIn: 'root',
})
export abstract class CacheService {
  usersDataModified$ = new Subject<CacheUsersInitiator>();
  evidencesDataModified$ = new Subject<CacheEvidencesInitiator>();
  autoClearFiltersUpdated$ = new Subject<boolean>();

  constructor() {}

  abstract cacheUsers(userUid: string, initiator: CacheUsersInitiator, identifier?: string): Observable<void>;

  abstract cacheEvidences(userUid: string, initiator: CacheEvidencesInitiator): Observable<void>;

  abstract usersDataModified(initiator: CacheUsersInitiator): void;

  abstract evidencesDataModified(initiator: CacheEvidencesInitiator): void;

  abstract storeUserDefaultQueryLocalStorage(userUid: string): void;

  abstract storeEvidenceDefaultQueryLocalStorage(userUid: string): void;

  abstract storeUserQueryLocalStorage(query: string): void;

  abstract storeEvidenceQueryLocalStorage(query: string): void;

  abstract getUserLocalStorageQuery(userUid: string): string;

  abstract getEvidenceLocalStorageQuery(userUid: string): string;

  abstract autoClearFiltersUpdated(autoClearFilters: boolean): void;

  abstract clearFiltersFromLocalStorage(identifier: string): void;
}
